/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkRegistrationCreated,
  BulkRegistrationListResponse,
  BulkRegistrationOverviewResponse,
  BulkRegistrationResultsResponse,
  BulkRegistrationStatus,
  CreateBulkRegistrationRequest,
  CreateEnrolmentRequest,
  DeviceDetail,
  DeviceHistoryResponse,
  DeviceRecord,
  DevicesExportAcceptedResponse,
  DevicesExportRequest,
  DevicesExportStatusResponse,
  DevicesFilterOptionsResponse,
  DevicesOverviewResponse,
  EnrolmentRecord,
  GetBulkRegistrationResultsParams,
  GetBulkRegistrationsOverviewParams,
  GetDeviceHistoryParams,
  ListBulkRegistrationsParams,
  ListDevicesParams,
  ListDevicesResponse,
  ListOfflineUnlockCodesParams,
  LockDeviceRequest,
  LockDeviceResponse,
  OfflineUnlockCodeHistoryResponse,
  OfflineUnlockCodeRequest,
  OfflineUnlockCodeResponse,
  ProblemDetails,
  RegisterDeviceRequest,
  UnlockDeviceRequest,
  UnlockDeviceResponse,
  UpdateEnrolmentFinancingRequest
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * The tenant's device list.
 * @summary List the tenant's devices (device state, allowed actions, identifier search, page pagination)
 */
export const listDevices = (
    params?: ListDevicesParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ListDevicesResponse>(
      {url: `/v1/devices`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListDevicesQueryKey = (params?: ListDevicesParams,) => {
    return [
    `/v1/devices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDevicesQueryOptions = <TData = Awaited<ReturnType<typeof listDevices>>, TError = ProblemDetails>(params?: ListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDevicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDevices>>> = ({ signal }) => listDevices(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof listDevices>>>
export type ListDevicesQueryError = ProblemDetails


export function useListDevices<TData = Awaited<ReturnType<typeof listDevices>>, TError = ProblemDetails>(
 params: undefined |  ListDevicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDevices>>,
          TError,
          Awaited<ReturnType<typeof listDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDevices<TData = Awaited<ReturnType<typeof listDevices>>, TError = ProblemDetails>(
 params?: ListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDevices>>,
          TError,
          Awaited<ReturnType<typeof listDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDevices<TData = Awaited<ReturnType<typeof listDevices>>, TError = ProblemDetails>(
 params?: ListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the tenant's devices (device state, allowed actions, identifier search, page pagination)
 */

export function useListDevices<TData = Awaited<ReturnType<typeof listDevices>>, TError = ProblemDetails>(
 params?: ListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDevicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Registers one device from **exactly one** identifier — IMEI or serial, never both, never neither.
 * @summary Register a single device by exactly one identifier
 */
export const registerDevice = (
    registerDeviceRequest: RegisterDeviceRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceRecord>(
      {url: `/v1/devices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerDeviceRequest, signal
    },
      options);
    }




export const getRegisterDeviceMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerDevice>>, TError,{data: RegisterDeviceRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof registerDevice>>, TError,{data: RegisterDeviceRequest}, TContext> => {

const mutationKey = ['registerDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerDevice>>, {data: RegisterDeviceRequest}> = (props) => {
          const {data} = props ?? {};

          return  registerDevice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof registerDevice>>>
    export type RegisterDeviceMutationBody = RegisterDeviceRequest
    export type RegisterDeviceMutationError = ProblemDetails

    /**
 * @summary Register a single device by exactly one identifier
 */
export const useRegisterDevice = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerDevice>>, TError,{data: RegisterDeviceRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerDevice>>,
        TError,
        {data: RegisterDeviceRequest},
        TContext
      > => {
      return useMutation(getRegisterDeviceMutationOptions(options), queryClient);
    }
    /**
 * The Provisioning Queue: the tenant's uploads from the **last 30 days**, newest first, with enough per row to render the list and see what needs attention — status, `ui_state`, file name.
 * @summary List the tenant's recent bulk uploads
 */
export const listBulkRegistrations = (
    params?: ListBulkRegistrationsParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistrationListResponse>(
      {url: `/v1/devices/bulk-registrations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListBulkRegistrationsQueryKey = (params?: ListBulkRegistrationsParams,) => {
    return [
    `/v1/devices/bulk-registrations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBulkRegistrationsQueryOptions = <TData = Awaited<ReturnType<typeof listBulkRegistrations>>, TError = ProblemDetails>(params?: ListBulkRegistrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkRegistrations>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBulkRegistrationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBulkRegistrations>>> = ({ signal }) => listBulkRegistrations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBulkRegistrations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBulkRegistrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listBulkRegistrations>>>
export type ListBulkRegistrationsQueryError = ProblemDetails


export function useListBulkRegistrations<TData = Awaited<ReturnType<typeof listBulkRegistrations>>, TError = ProblemDetails>(
 params: undefined |  ListBulkRegistrationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkRegistrations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkRegistrations>>,
          TError,
          Awaited<ReturnType<typeof listBulkRegistrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkRegistrations<TData = Awaited<ReturnType<typeof listBulkRegistrations>>, TError = ProblemDetails>(
 params?: ListBulkRegistrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkRegistrations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkRegistrations>>,
          TError,
          Awaited<ReturnType<typeof listBulkRegistrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkRegistrations<TData = Awaited<ReturnType<typeof listBulkRegistrations>>, TError = ProblemDetails>(
 params?: ListBulkRegistrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkRegistrations>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the tenant's recent bulk uploads
 */

export function useListBulkRegistrations<TData = Awaited<ReturnType<typeof listBulkRegistrations>>, TError = ProblemDetails>(
 params?: ListBulkRegistrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkRegistrations>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBulkRegistrationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a bulk-registration operation and returns a short-lived presigned `PUT` ticket. **The CSV never passes through this API.** A million-row file is data-plane traffic and this is a control…
 * @summary Declare a bulk upload and receive a presigned PUT ticket
 */
export const createBulkRegistration = (
    createBulkRegistrationRequest: CreateBulkRegistrationRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistrationCreated>(
      {url: `/v1/devices/bulk-registrations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkRegistrationRequest, signal
    },
      options);
    }




export const getCreateBulkRegistrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError,{data: CreateBulkRegistrationRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError,{data: CreateBulkRegistrationRequest}, TContext> => {

const mutationKey = ['createBulkRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkRegistration>>, {data: CreateBulkRegistrationRequest}> = (props) => {
          const {data} = props ?? {};

          return  createBulkRegistration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkRegistration>>>
    export type CreateBulkRegistrationMutationBody = CreateBulkRegistrationRequest
    export type CreateBulkRegistrationMutationError = ProblemDetails

    /**
 * @summary Declare a bulk upload and receive a presigned PUT ticket
 */
export const useCreateBulkRegistration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError,{data: CreateBulkRegistrationRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkRegistration>>,
        TError,
        {data: CreateBulkRegistrationRequest},
        TContext
      > => {
      return useMutation(getCreateBulkRegistrationMutationOptions(options), queryClient);
    }
    /**
 * The cards above the Provisioning Queue: `in_progress`, `completed`, `need_attention` and `failed`, in **devices** (CSV rows), over the uploads the list would show for the same `state` and `q`.
 * @summary The Provisioning Queue's three cards, with previous period and daily series
 */
export const getBulkRegistrationsOverview = (
    params?: GetBulkRegistrationsOverviewParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistrationOverviewResponse>(
      {url: `/v1/devices/bulk-registrations/overview`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetBulkRegistrationsOverviewQueryKey = (params?: GetBulkRegistrationsOverviewParams,) => {
    return [
    `/v1/devices/bulk-registrations/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBulkRegistrationsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError = ProblemDetails>(params?: GetBulkRegistrationsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkRegistrationsOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>> = ({ signal }) => getBulkRegistrationsOverview(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkRegistrationsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>>
export type GetBulkRegistrationsOverviewQueryError = ProblemDetails


export function useGetBulkRegistrationsOverview<TData = Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError = ProblemDetails>(
 params: undefined |  GetBulkRegistrationsOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistrationsOverview>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistrationsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistrationsOverview<TData = Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError = ProblemDetails>(
 params?: GetBulkRegistrationsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistrationsOverview>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistrationsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistrationsOverview<TData = Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError = ProblemDetails>(
 params?: GetBulkRegistrationsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Provisioning Queue's three cards, with previous period and daily series
 */

export function useGetBulkRegistrationsOverview<TData = Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError = ProblemDetails>(
 params?: GetBulkRegistrationsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkRegistrationsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The published header the `start` route validates against, as a one-line CSV the operator fills in.
 * @summary Download the bulk upload CSV template
 */
export const getBulkRegistrationTemplate = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<string>(
      {url: `/v1/devices/bulk-registrations/template`, method: 'GET', signal
    },
      options);
    }




export const getGetBulkRegistrationTemplateQueryKey = () => {
    return [
    `/v1/devices/bulk-registrations/template`
    ] as const;
    }


export const getGetBulkRegistrationTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkRegistrationTemplateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>> = ({ signal }) => getBulkRegistrationTemplate(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkRegistrationTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>>
export type GetBulkRegistrationTemplateQueryError = ProblemDetails


export function useGetBulkRegistrationTemplate<TData = Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistrationTemplate>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistrationTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistrationTemplate<TData = Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistrationTemplate>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistrationTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistrationTemplate<TData = Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the bulk upload CSV template
 */

export function useGetBulkRegistrationTemplate<TData = Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkRegistrationTemplateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The operation's progress and its outcome counts.
 * @summary One upload's progress, per batch and overall
 */
export const getBulkRegistration = (
    id: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistrationStatus>(
      {url: `/v1/devices/bulk-registrations/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetBulkRegistrationQueryKey = (id: string,) => {
    return [
    `/v1/devices/bulk-registrations/${id}`
    ] as const;
    }


export const getGetBulkRegistrationQueryOptions = <TData = Awaited<ReturnType<typeof getBulkRegistration>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkRegistrationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkRegistration>>> = ({ signal }) => getBulkRegistration(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkRegistration>>>
export type GetBulkRegistrationQueryError = ProblemDetails


export function useGetBulkRegistration<TData = Awaited<ReturnType<typeof getBulkRegistration>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistration>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistration<TData = Awaited<ReturnType<typeof getBulkRegistration>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistration>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistration<TData = Awaited<ReturnType<typeof getBulkRegistration>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One upload's progress, per batch and overall
 */

export function useGetBulkRegistration<TData = Awaited<ReturnType<typeof getBulkRegistration>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkRegistrationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Re-sends the rows of one `FAILED` batch.
 * @summary Re-send one failed batch
 */
export const retryBulkRegistrationBatch = (
    id: string,
    batchIndex: number,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistrationStatus>(
      {url: `/v1/devices/bulk-registrations/${id}/batches/${batchIndex}/retry`, method: 'POST', signal
    },
      options);
    }




export const getRetryBulkRegistrationBatchMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError,{id: string;batchIndex: number}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError,{id: string;batchIndex: number}, TContext> => {

const mutationKey = ['retryBulkRegistrationBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, {id: string;batchIndex: number}> = (props) => {
          const {id,batchIndex} = props ?? {};

          return  retryBulkRegistrationBatch(id,batchIndex,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryBulkRegistrationBatchMutationResult = NonNullable<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>>

    export type RetryBulkRegistrationBatchMutationError = ProblemDetails

    /**
 * @summary Re-send one failed batch
 */
export const useRetryBulkRegistrationBatch = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError,{id: string;batchIndex: number}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryBulkRegistrationBatch>>,
        TError,
        {id: string;batchIndex: number},
        TContext
      > => {
      return useMutation(getRetryBulkRegistrationBatchMutationOptions(options), queryClient);
    }
    /**
 * The rows that need the operator's attention, with their identifiers.
 * @summary Get a download link for the failed-devices workbook
 */
export const getBulkRegistrationResults = (
    id: string,
    params?: GetBulkRegistrationResultsParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistrationResultsResponse>(
      {url: `/v1/devices/bulk-registrations/${id}/results`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetBulkRegistrationResultsQueryKey = (id: string,
    params?: GetBulkRegistrationResultsParams,) => {
    return [
    `/v1/devices/bulk-registrations/${id}/results`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBulkRegistrationResultsQueryOptions = <TData = Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError = ProblemDetails>(id: string,
    params?: GetBulkRegistrationResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkRegistrationResultsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkRegistrationResults>>> = ({ signal }) => getBulkRegistrationResults(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkRegistrationResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkRegistrationResults>>>
export type GetBulkRegistrationResultsQueryError = ProblemDetails


export function useGetBulkRegistrationResults<TData = Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError = ProblemDetails>(
 id: string,
    params: undefined |  GetBulkRegistrationResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistrationResults>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistrationResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistrationResults<TData = Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError = ProblemDetails>(
 id: string,
    params?: GetBulkRegistrationResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkRegistrationResults>>,
          TError,
          Awaited<ReturnType<typeof getBulkRegistrationResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkRegistrationResults<TData = Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError = ProblemDetails>(
 id: string,
    params?: GetBulkRegistrationResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a download link for the failed-devices workbook
 */

export function useGetBulkRegistrationResults<TData = Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError = ProblemDetails>(
 id: string,
    params?: GetBulkRegistrationResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkRegistrationResultsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The dropdown options of the Devices page's filter bar, so the portal never offers a value that matches no device.
 * @summary The options of the device table's Service, Plan, State and Batch filters
 */
export const getDevicesFilterOptions = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DevicesFilterOptionsResponse>(
      {url: `/v1/devices/filter-options`, method: 'GET', signal
    },
      options);
    }




export const getGetDevicesFilterOptionsQueryKey = () => {
    return [
    `/v1/devices/filter-options`
    ] as const;
    }


export const getGetDevicesFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevicesFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevicesFilterOptions>>> = ({ signal }) => getDevicesFilterOptions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevicesFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getDevicesFilterOptions>>>
export type GetDevicesFilterOptionsQueryError = ProblemDetails


export function useGetDevicesFilterOptions<TData = Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevicesFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getDevicesFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevicesFilterOptions<TData = Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevicesFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getDevicesFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevicesFilterOptions<TData = Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The options of the device table's Service, Plan, State and Batch filters
 */

export function useGetDevicesFilterOptions<TData = Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevicesFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The three Overview cards of the Devices page: `total`, `need_attention` and `synced_24h_pct`, each with `current` and `previous` (the value at 00:00 UTC today).
 * @summary The Devices page Overview cards — each with its previous-day value
 */
export const getDevicesOverview = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DevicesOverviewResponse>(
      {url: `/v1/devices/overview`, method: 'GET', signal
    },
      options);
    }




export const getGetDevicesOverviewQueryKey = () => {
    return [
    `/v1/devices/overview`
    ] as const;
    }


export const getGetDevicesOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getDevicesOverview>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevicesOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevicesOverview>>> = ({ signal }) => getDevicesOverview(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevicesOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevicesOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getDevicesOverview>>>
export type GetDevicesOverviewQueryError = ProblemDetails


export function useGetDevicesOverview<TData = Awaited<ReturnType<typeof getDevicesOverview>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevicesOverview>>,
          TError,
          Awaited<ReturnType<typeof getDevicesOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevicesOverview<TData = Awaited<ReturnType<typeof getDevicesOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevicesOverview>>,
          TError,
          Awaited<ReturnType<typeof getDevicesOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevicesOverview<TData = Awaited<ReturnType<typeof getDevicesOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Devices page Overview cards — each with its previous-day value
 */

export function useGetDevicesOverview<TData = Awaited<ReturnType<typeof getDevicesOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesOverview>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevicesOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The tenant's device detail: hardware/OS/app/SIM attributes populated at the device's first check-in.
 * @summary One device's full detail — attributes, connectivity, state and the latest command
 */
export const getDeviceDetail = (
    deviceId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceDetail>(
      {url: `/v1/devices/${deviceId}`, method: 'GET', signal
    },
      options);
    }




export const getGetDeviceDetailQueryKey = (deviceId: string,) => {
    return [
    `/v1/devices/${deviceId}`
    ] as const;
    }


export const getGetDeviceDetailQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceDetail>>, TError = ProblemDetails>(deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceDetail>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceDetailQueryKey(deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceDetail>>> = ({ signal }) => getDeviceDetail(deviceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: deviceId !== null && deviceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeviceDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceDetail>>>
export type GetDeviceDetailQueryError = ProblemDetails


export function useGetDeviceDetail<TData = Awaited<ReturnType<typeof getDeviceDetail>>, TError = ProblemDetails>(
 deviceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceDetail>>,
          TError,
          Awaited<ReturnType<typeof getDeviceDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceDetail<TData = Awaited<ReturnType<typeof getDeviceDetail>>, TError = ProblemDetails>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceDetail>>,
          TError,
          Awaited<ReturnType<typeof getDeviceDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceDetail<TData = Awaited<ReturnType<typeof getDeviceDetail>>, TError = ProblemDetails>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceDetail>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One device's full detail — attributes, connectivity, state and the latest command
 */

export function useGetDeviceDetail<TData = Awaited<ReturnType<typeof getDeviceDetail>>, TError = ProblemDetails>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceDetail>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceDetailQueryOptions(deviceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * One merged timeline for the device, newest first: commands issued and acknowledged, enrolment state changes and policy outcomes.
 * @summary The device's history timeline — the device detail's History tab
 */
export const getDeviceHistory = (
    deviceId: string,
    params?: GetDeviceHistoryParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceHistoryResponse>(
      {url: `/v1/devices/${deviceId}/history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDeviceHistoryQueryKey = (deviceId: string,
    params?: GetDeviceHistoryParams,) => {
    return [
    `/v1/devices/${deviceId}/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDeviceHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceHistory>>, TError = ProblemDetails>(deviceId: string,
    params?: GetDeviceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceHistoryQueryKey(deviceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceHistory>>> = ({ signal }) => getDeviceHistory(deviceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: deviceId !== null && deviceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeviceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceHistory>>>
export type GetDeviceHistoryQueryError = ProblemDetails


export function useGetDeviceHistory<TData = Awaited<ReturnType<typeof getDeviceHistory>>, TError = ProblemDetails>(
 deviceId: string,
    params: undefined |  GetDeviceHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceHistory>>,
          TError,
          Awaited<ReturnType<typeof getDeviceHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceHistory<TData = Awaited<ReturnType<typeof getDeviceHistory>>, TError = ProblemDetails>(
 deviceId: string,
    params?: GetDeviceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceHistory>>,
          TError,
          Awaited<ReturnType<typeof getDeviceHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceHistory<TData = Awaited<ReturnType<typeof getDeviceHistory>>, TError = ProblemDetails>(
 deviceId: string,
    params?: GetDeviceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The device's history timeline — the device detail's History tab
 */

export function useGetDeviceHistory<TData = Awaited<ReturnType<typeof getDeviceHistory>>, TError = ProblemDetails>(
 deviceId: string,
    params?: GetDeviceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHistory>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceHistoryQueryOptions(deviceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Issues a Full Lock against the device.
 * @summary Issue a Full Lock (async — 202 means recorded and queued, never applied)
 */
export const lockDevice = (
    deviceId: string,
    lockDeviceRequest?: LockDeviceRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<LockDeviceResponse>(
      {url: `/v1/devices/${deviceId}/lock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lockDeviceRequest, signal
    },
      options);
    }




export const getLockDeviceMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockDevice>>, TError,{deviceId: string;data?: LockDeviceRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof lockDevice>>, TError,{deviceId: string;data?: LockDeviceRequest}, TContext> => {

const mutationKey = ['lockDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockDevice>>, {deviceId: string;data?: LockDeviceRequest}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  lockDevice(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LockDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof lockDevice>>>
    export type LockDeviceMutationBody = LockDeviceRequest | undefined
    export type LockDeviceMutationError = ProblemDetails

    /**
 * @summary Issue a Full Lock (async — 202 means recorded and queued, never applied)
 */
export const useLockDevice = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockDevice>>, TError,{deviceId: string;data?: LockDeviceRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lockDevice>>,
        TError,
        {deviceId: string;data?: LockDeviceRequest},
        TContext
      > => {
      return useMutation(getLockDeviceMutationOptions(options), queryClient);
    }
    /**
 * PROPOSAL pending CEN-167 Security sign-off.
 * @summary Generate an offline unlock code for a challenge shown on the device (201 new, 200 repeat)
 */
export const generateOfflineUnlockCode = (
    deviceId: string,
    offlineUnlockCodeRequest: OfflineUnlockCodeRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<OfflineUnlockCodeResponse>(
      {url: `/v1/devices/${deviceId}/offline-unlock-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: offlineUnlockCodeRequest, signal
    },
      options);
    }




export const getGenerateOfflineUnlockCodeMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOfflineUnlockCode>>, TError,{deviceId: string;data: OfflineUnlockCodeRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof generateOfflineUnlockCode>>, TError,{deviceId: string;data: OfflineUnlockCodeRequest}, TContext> => {

const mutationKey = ['generateOfflineUnlockCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateOfflineUnlockCode>>, {deviceId: string;data: OfflineUnlockCodeRequest}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  generateOfflineUnlockCode(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateOfflineUnlockCodeMutationResult = NonNullable<Awaited<ReturnType<typeof generateOfflineUnlockCode>>>
    export type GenerateOfflineUnlockCodeMutationBody = OfflineUnlockCodeRequest
    export type GenerateOfflineUnlockCodeMutationError = ProblemDetails

    /**
 * @summary Generate an offline unlock code for a challenge shown on the device (201 new, 200 repeat)
 */
export const useGenerateOfflineUnlockCode = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOfflineUnlockCode>>, TError,{deviceId: string;data: OfflineUnlockCodeRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateOfflineUnlockCode>>,
        TError,
        {deviceId: string;data: OfflineUnlockCodeRequest},
        TContext
      > => {
      return useMutation(getGenerateOfflineUnlockCodeMutationOptions(options), queryClient);
    }
    /**
 * Issues an Unlock against the device.
 * @summary Issue an Unlock (async — 202 means recorded and queued, never applied)
 */
export const unlockDevice = (
    deviceId: string,
    unlockDeviceRequest?: UnlockDeviceRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<UnlockDeviceResponse>(
      {url: `/v1/devices/${deviceId}/unlock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unlockDeviceRequest, signal
    },
      options);
    }




export const getUnlockDeviceMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockDevice>>, TError,{deviceId: string;data?: UnlockDeviceRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unlockDevice>>, TError,{deviceId: string;data?: UnlockDeviceRequest}, TContext> => {

const mutationKey = ['unlockDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockDevice>>, {deviceId: string;data?: UnlockDeviceRequest}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  unlockDevice(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof unlockDevice>>>
    export type UnlockDeviceMutationBody = UnlockDeviceRequest | undefined
    export type UnlockDeviceMutationError = ProblemDetails

    /**
 * @summary Issue an Unlock (async — 202 means recorded and queued, never applied)
 */
export const useUnlockDevice = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockDevice>>, TError,{deviceId: string;data?: UnlockDeviceRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlockDevice>>,
        TError,
        {deviceId: string;data?: UnlockDeviceRequest},
        TContext
      > => {
      return useMutation(getUnlockDeviceMutationOptions(options), queryClient);
    }
    /**
 * Binds one registered device to one commercial service: DF Post-paid lands in `ENROLLED`, Supply Chain in `PROTECTED`.
 * @summary Enrol one registered device, named by its IMEI, into a service (sync — 201 means the enrolment exists)
 */
export const createEnrolment = (
    createEnrolmentRequest: CreateEnrolmentRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<EnrolmentRecord>(
      {url: `/v1/enrolments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEnrolmentRequest, signal
    },
      options);
    }




export const getCreateEnrolmentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEnrolment>>, TError,{data: CreateEnrolmentRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createEnrolment>>, TError,{data: CreateEnrolmentRequest}, TContext> => {

const mutationKey = ['createEnrolment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEnrolment>>, {data: CreateEnrolmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createEnrolment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEnrolmentMutationResult = NonNullable<Awaited<ReturnType<typeof createEnrolment>>>
    export type CreateEnrolmentMutationBody = CreateEnrolmentRequest
    export type CreateEnrolmentMutationError = ProblemDetails

    /**
 * @summary Enrol one registered device, named by its IMEI, into a service (sync — 201 means the enrolment exists)
 */
export const useCreateEnrolment = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEnrolment>>, TError,{data: CreateEnrolmentRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEnrolment>>,
        TError,
        {data: CreateEnrolmentRequest},
        TContext
      > => {
      return useMutation(getCreateEnrolmentMutationOptions(options), queryClient);
    }
    /**
 * Where `due_date` and `loan_reference` went when the 12 Oct 2026 Product ruling took them off the creation wire: the tenant's own billing system sets them after creation. dfpost only.
 * @summary Set a dfpost enrolment's financing fields (tenant system's route)
 */
export const updateEnrolmentFinancing = (
    enrolmentId: string,
    updateEnrolmentFinancingRequest: UpdateEnrolmentFinancingRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/enrolments/${enrolmentId}/financing`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateEnrolmentFinancingRequest, signal
    },
      options);
    }




export const getUpdateEnrolmentFinancingMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnrolmentFinancing>>, TError,{enrolmentId: string;data: UpdateEnrolmentFinancingRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEnrolmentFinancing>>, TError,{enrolmentId: string;data: UpdateEnrolmentFinancingRequest}, TContext> => {

const mutationKey = ['updateEnrolmentFinancing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEnrolmentFinancing>>, {enrolmentId: string;data: UpdateEnrolmentFinancingRequest}> = (props) => {
          const {enrolmentId,data} = props ?? {};

          return  updateEnrolmentFinancing(enrolmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEnrolmentFinancingMutationResult = NonNullable<Awaited<ReturnType<typeof updateEnrolmentFinancing>>>
    export type UpdateEnrolmentFinancingMutationBody = UpdateEnrolmentFinancingRequest
    export type UpdateEnrolmentFinancingMutationError = ProblemDetails

    /**
 * @summary Set a dfpost enrolment's financing fields (tenant system's route)
 */
export const useUpdateEnrolmentFinancing = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnrolmentFinancing>>, TError,{enrolmentId: string;data: UpdateEnrolmentFinancingRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEnrolmentFinancing>>,
        TError,
        {enrolmentId: string;data: UpdateEnrolmentFinancingRequest},
        TContext
      > => {
      return useMutation(getUpdateEnrolmentFinancingMutationOptions(options), queryClient);
    }
    /**
 * Starts writing every device that matches the body's search and filters (the GET /v1/devices parameters of the same names, across all pages) to a CSV, in the background, and answers at once.
 * @summary Start a CSV export of the devices matching the table's search and filters
 */
export const startDevicesExport = (
    devicesExportRequest?: DevicesExportRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DevicesExportAcceptedResponse>(
      {url: `/v1/exports/devices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: devicesExportRequest, signal
    },
      options);
    }




export const getStartDevicesExportMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDevicesExport>>, TError,{data?: DevicesExportRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof startDevicesExport>>, TError,{data?: DevicesExportRequest}, TContext> => {

const mutationKey = ['startDevicesExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startDevicesExport>>, {data?: DevicesExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  startDevicesExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartDevicesExportMutationResult = NonNullable<Awaited<ReturnType<typeof startDevicesExport>>>
    export type StartDevicesExportMutationBody = DevicesExportRequest | undefined
    export type StartDevicesExportMutationError = ProblemDetails

    /**
 * @summary Start a CSV export of the devices matching the table's search and filters
 */
export const useStartDevicesExport = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDevicesExport>>, TError,{data?: DevicesExportRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startDevicesExport>>,
        TError,
        {data?: DevicesExportRequest},
        TContext
      > => {
      return useMutation(getStartDevicesExportMutationOptions(options), queryClient);
    }
    /**
 * PENDING while the CSV is written, READY with a one-hour presigned download link, FAILED with the failed run's `request_id`.
 * @summary The state of a CSV export, with its download link once READY
 */
export const getDevicesExport = (
    exportId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DevicesExportStatusResponse>(
      {url: `/v1/exports/devices/${exportId}`, method: 'GET', signal
    },
      options);
    }




export const getGetDevicesExportQueryKey = (exportId: string,) => {
    return [
    `/v1/exports/devices/${exportId}`
    ] as const;
    }


export const getGetDevicesExportQueryOptions = <TData = Awaited<ReturnType<typeof getDevicesExport>>, TError = ProblemDetails>(exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesExport>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevicesExportQueryKey(exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevicesExport>>> = ({ signal }) => getDevicesExport(exportId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: exportId !== null && exportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevicesExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevicesExportQueryResult = NonNullable<Awaited<ReturnType<typeof getDevicesExport>>>
export type GetDevicesExportQueryError = ProblemDetails


export function useGetDevicesExport<TData = Awaited<ReturnType<typeof getDevicesExport>>, TError = ProblemDetails>(
 exportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevicesExport>>,
          TError,
          Awaited<ReturnType<typeof getDevicesExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevicesExport<TData = Awaited<ReturnType<typeof getDevicesExport>>, TError = ProblemDetails>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevicesExport>>,
          TError,
          Awaited<ReturnType<typeof getDevicesExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevicesExport<TData = Awaited<ReturnType<typeof getDevicesExport>>, TError = ProblemDetails>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesExport>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The state of a CSV export, with its download link once READY
 */

export function useGetDevicesExport<TData = Awaited<ReturnType<typeof getDevicesExport>>, TError = ProblemDetails>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevicesExport>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevicesExportQueryOptions(exportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * PROPOSAL pending CEN-167 Security sign-off.
 * @summary List a device's offline unlock code history (never returns a code)
 */
export const listOfflineUnlockCodes = (
    params: ListOfflineUnlockCodesParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<OfflineUnlockCodeHistoryResponse>(
      {url: `/v1/offline-unlock-codes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListOfflineUnlockCodesQueryKey = (params?: ListOfflineUnlockCodesParams,) => {
    return [
    `/v1/offline-unlock-codes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOfflineUnlockCodesQueryOptions = <TData = Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError = ProblemDetails>(params: ListOfflineUnlockCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOfflineUnlockCodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOfflineUnlockCodes>>> = ({ signal }) => listOfflineUnlockCodes(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOfflineUnlockCodesQueryResult = NonNullable<Awaited<ReturnType<typeof listOfflineUnlockCodes>>>
export type ListOfflineUnlockCodesQueryError = ProblemDetails


export function useListOfflineUnlockCodes<TData = Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError = ProblemDetails>(
 params: ListOfflineUnlockCodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfflineUnlockCodes>>,
          TError,
          Awaited<ReturnType<typeof listOfflineUnlockCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfflineUnlockCodes<TData = Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError = ProblemDetails>(
 params: ListOfflineUnlockCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfflineUnlockCodes>>,
          TError,
          Awaited<ReturnType<typeof listOfflineUnlockCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfflineUnlockCodes<TData = Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError = ProblemDetails>(
 params: ListOfflineUnlockCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a device's offline unlock code history (never returns a code)
 */

export function useListOfflineUnlockCodes<TData = Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError = ProblemDetails>(
 params: ListOfflineUnlockCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfflineUnlockCodes>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOfflineUnlockCodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






